module.exports = __webpack_public_path__ + "static/media/header_v2.bd039e21.jpg";